import { Color } from '@wix/document-services-types/src/style/dataTypes';

const compareColors = (
  value1: Color | undefined,
  value2: Color | undefined,
): boolean => {
  if (!value1 && !value2) {
    return true;
  }
  if (!value1 || !value2) {
    return false;
  }

  if (value1.type === 'HexColor' && value2.type === 'HexColor') {
    return value1.value === value2.value;
  }

  if (value1.type === 'ColorFunction' && value2.type === 'ColorFunction') {
    return (
      value1.function === value2.function && value1.values === value2.values
    );
  }

  if (value1.type === 'LightDark' && value2.type === 'LightDark') {
    return (
      compareColors(value1.light, value2.light) &&
      compareColors(value1.dark, value2.dark)
    );
  }

  if (value1.type === 'Keyword' && value2.type === 'Keyword') {
    return value1.value === value2.value;
  }

  if (
    value1.type === 'RelativeColorFunction' &&
    value2.type === 'RelativeColorFunction'
  ) {
    return (
      value1.function === value2.function && value1.values === value2.values
    );
  }

  return false;
};

export default compareColors;
